<script setup>
import { ref } from "vue"
import {__, _mareike_nonce} from "../../../assets/javascripts/library";
import Modal from "../../../assets/components/Modal.vue";
import FullScreenModal from "../../../assets/components/FullScreenModal.vue";
import InvoiceDetails from "./MyInvoiceDetails.vue";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },

  deep_jump_id: {
    type: Number,
    default: 0
  },

  invoice_id: {
    type: Number,
    default: 0
  }
})

const local_data = ref(props.data)
const show_invoice = ref(false)
const invoice = ref(null)

if (props.deep_jump_id > 0) {
  open_invoice(props.deep_jump_id)
}

async function open_invoice(id) {
  const url = `/wp-json/mareike/invoices/show?invoice-id=${id}&mareike_nonce=`+_mareike_nonce()

  try {
    const response = await fetch(url, { method: 'GET' })
    if (!response.ok) throw new Error('Fehler beim Laden')

    const result = await response.json()
    invoice.value = result.invoice
    show_invoice.value = true
  } catch (err) {
    console.error('Error fetching invoices:', err)
  }
}


async function reload() {
  const url = `/wp-json/mareike/my-invoices/new-invoices?mareike_nonce=`+_mareike_nonce()

  try {
    const response = await fetch(url, { method: 'GET' })
    if (!response.ok) throw new Error('Fehler beim Laden')

    const result = await response.json()
    local_data.value = result

  } catch (err) {
    console.error('Error fetching invoices:', err)
  }
}
</script>

<template>
  <table class="wp-list-table widefat fixed striped posts listinvoices" style="width: 95%;">
    <thead>
    <tr>
      <th colspan="5">
        {{ local_data.headline }}
      </th>
    </tr>
    </thead>
    <tr v-for="invoice in local_data.invoices" :key="invoice.id">
      <td>{{ invoice.invoice_number}}</td>
      <td>{{ invoice.type }}</td>
      <td>{{ invoice.amount }}</td>
      <td>{{invoice.contact_name}}<br />{{invoice.contact_email}}</td>
      <td>
        <button type="button" class="mareike-button loadinvoice" @click="open_invoice(invoice.id)">
          {{__('Show invoice', 'mareike')}}
        </button>
      </td>
    </tr>
  </table>

  <InvoiceDetails :data="invoice" :show-invoice="show_invoice" v-if="show_invoice" @close="show_invoice = false; reload()" />
</template>

<style scoped>
.listinvoices {
  width: 100%;
  font-weight: normal;
}

.listinvoices tr th {
  text-align: left;
}

.loadinvoice {
  padding: 5px 7px !important;
}
</style>
